<template>
  <img
    src="/my-logo.png"
    height="32"
    width="32"
    :alt="brandName"
    class="rounded-md"
  />
</template>

<script>
import { useBrand } from '@/composables/useBrand'

export default {
  name: 'ProjectLogo',
  setup() {
    const { brandName } = useBrand()

    return {
      brandName
    }
  }
}
</script>
